// src/pages/GoldLoanCard.jsx
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { fetchGoldLoanEmis } from "../redux/slices/goldLoanEmiSlice";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import "../css/LoanCardPage.css";

// Utility: format date as DD-MM-YYYY
const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  if (isNaN(date)) return dateStr;
  return date.toLocaleDateString("en-GB");
};

// Utility: format amount as Rs XXXX
const formatAmount = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) return "Rs 0";
  return `Rs ${Number(amount).toLocaleString("en-IN")}`;
};

const GoldLoanCard = () => {
  const { loanId } = useParams();
  const { state } = useLocation();
  const loan = state;

  const dispatch = useDispatch();

  const {
    dueReport = [],
    loading,
    error,
  } = useSelector((state) => state.goldLoanEmi);

  const [allEmis, setAllEmis] = useState([]);
  const [company, setCompany] = useState(null);

  const superAdminId = Number(localStorage.getItem("adminuserId")) || 0;

  // const fetchPageData = (page) => {
  //   dispatch(
  //     fetchGoldLoanEmis({
  //       superAdminId,
  //       goldLoanId: loanId,
  //       page,
  //       pageSize:1000,
  //     })
  //   );
  // };


const fetchAllEmis = async () => {
  try {
    let page = 1;
    let allData = [];
    let totalPages = 1;

    while (page <= totalPages) {
      const result = await dispatch(
        fetchGoldLoanEmis({
          superAdminId,
          goldLoanId: loanId,
          page,
          pageSize: 1000,
        })
      ).unwrap();

      const emis = result.data || [];

      allData = [...allData, ...emis];

      totalPages = result.pagination.totalPages || 1;

      page++;
    }

    setAllEmis(allData);
  } catch (err) {
    console.error(err);
  }
};

  useEffect(() => {
    if (loanId && superAdminId) {
  fetchAllEmis();
}

    const fetchCompany = async () => {
      try {
        const res = await fetch(
          `https://payyug.in/api/get-company?superAdminId=${superAdminId}`
        );

        const data = await res.json();

        if (res.ok && data) {
          if (data.logo) {
            data.logoUrl = `https://payyug.in/${data.logo.replace(
              /^images\//,
              ""
            )}`;
          }

          setCompany(data);
        }
      } catch (err) {
        console.error("Error fetching company details:", err);
      }
    };

    if (superAdminId) fetchCompany();
  }, [loanId, superAdminId,dispatch]);

  const emiAmountFromSchedule = dueReport?.[0]?.emiAmount || 0;

  // DOWNLOAD PDF
  const downloadPageAsPDF = async () => {
    if (!loan) return;

    const doc = new jsPDF("p", "mm", "a4");

    const margin = 14;
    let y = 20;

    const pageWidth = doc.internal.pageSize.getWidth();
    const centerX = pageWidth / 2;

    if (company?.logoUrl) {
      try {
        const img = await fetch(company.logoUrl);
        const blob = await img.blob();
        const reader = new FileReader();

        reader.onload = function (e) {
          const imgData = e.target.result;

          doc.addImage(imgData, "PNG", margin, y, 30, 30);

          doc.setDrawColor(200);
          doc.circle(margin + 15, y + 15, 16);

          doc.setFont("helvetica", "bold");
          doc.setFontSize(16);

          doc.text(company?.name || "Company Name", centerX, y + 8, {
            align: "center",
          });

          doc.setFont("helvetica", "normal");
          doc.setFontSize(10);

          if (company?.cin)
            doc.text(`CIN: ${company.cin}`, centerX, y + 16, {
              align: "center",
            });

          if (company?.address)
            doc.text(`Regt. Office: ${company.address}`, centerX, y + 22, {
              align: "center",
            });

          doc.text(`Email: ${company?.email || "-"}`, centerX, y + 28, {
            align: "center",
          });

          doc.text(`Ph: ${company?.contact || "-"}`, centerX, y + 34, {
            align: "center",
          });

          y += 38;

          doc.setDrawColor(180);
          doc.line(margin, y, pageWidth - margin, y);

          y += 10;

          doc.setFont("helvetica", "bold");
          doc.setFontSize(14);

          doc.text("GOLD LOAN CARD", centerX, y, { align: "center" });

          y += 10;

          printBody();
        };

        reader.readAsDataURL(blob);
      } catch (e) {
        console.error("Logo load error:", e);
        printBody();
      }
    } else {
      printBody();
    }

    function printBody() {
      doc.setFontSize(13);
      doc.setFont("helvetica", "bold");

      doc.text("Customer & Loan Details", margin, y);

      y += 8;

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");

      doc.text(`Customer Name: ${loan.userName}`, margin, y);
      doc.text(`Loan No: ${loan.loanAccountNumber}`, 120, y);

      y += 6;
      
      doc.text(`Loan Amount: ${formatAmount(loan.loanAmount)}`, margin, y);
      doc.text(`EMI Amount: ${formatAmount(emiAmountFromSchedule)}`, 120, y);
      
      y += 6;
      
      doc.text(`Number of EMIs: ${allEmis.length}`, margin, y);
      doc.text(`Branch: ${loan.branch || "NA"}`, 120, y);

      y += 6;
      doc.text(
        `Exit Amount: ${formatAmount(loan.exitAmount || loan.loanPayable)}`,
       margin, y
      );

      y += 10;

      const tableData = allEmis.map((emi, i) => [
        i + 1,
        formatDate(emi.dueDate),
        formatAmount(emi.principalComponent),
        formatAmount(emi.interestComponent),
        formatAmount(emi.emiAmount),
        emi.paymentDate ? formatDate(emi.paymentDate) : "-",
        "",
        "",
      ]);

      autoTable(doc, {
        startY: y,
        head: [
          [
            "EMI No",
            "Due Date",
            "Principal",
            "Interest",
            "EMI Amount",
            "Paid Date",
            "Staff Sign",
            "Customer Sign",
          ],
        ],
        body: tableData,
        styles: { fontSize: 9 },
        theme: "grid",
        headStyles: { fillColor: [16, 144, 191], textColor: 255 },
        margin: { left: margin, right: margin },
      });

      doc.save(
        `LoanCard_${loan.loanAccountNumber || loan.loanNumber}.pdf`
      );
    }
  };

  if (loading)
    return <div className="AdminLoanCardPage-loading">Loading...</div>;

  if (error)
    return <div className="AdminLoanCardPage-error">{error}</div>;

  if (!loan)
    return (
      <div className="AdminLoanCardPage-empty">
        No Gold loan found for Loan ID {loanId}
      </div>
    );

  return (
    <div className="AdminLoanCardPage-container">
      <header className="AdminLoanCardPage-header">
        <div className="LoanCard-logo-container">
          {company?.logoUrl && (
            <img src={company.logoUrl} alt="Logo" className="LoanCard-logo" />
          )}
        </div>

        <div className="LoanCard-company-info-right">
          <h2 className="company-name">{company?.name || "Company Name"}</h2>

          {company?.cin && (
            <p>
              <strong>CIN:</strong> {company.cin}
            </p>
          )}

          {company?.address && (
            <p>
              <strong>Regt. Office:</strong>
              {company.address}
            </p>
          )}

          {company?.email && (
            <p>
              <strong>Email:</strong> {company.email}
            </p>
          )}

          {company?.contact && (
            <p>
              <strong>Contact:</strong> {company.contact}
            </p>
          )}
        </div>

        <div style={{ opacity: 0 }} className="LoanCard-logo-container">
          {company?.logoUrl && (
            <img src={company.logoUrl} alt="Logo" className="LoanCard-logo" />
          )}
        </div>
      </header>

      <div className="LoanCard-title-center">
        <h3>Gold Loan Card</h3>
      </div>

      <section className="AdminLoanCardPage-details">
        <div>
          <strong>Customer Name:</strong> {loan.userName}
        </div>

        <div>
          <strong>customer Id:</strong> {loan.customerId || "NA"}
        </div>

        <div>
          <strong>Loan Number:</strong> {loan.loanAccountNumber}
        </div>

        <div>
          <strong>Plan Name:</strong> {loan.loanType || loan.planName || "NA"}
        </div>

        <div>
          <strong>Loan Amount:</strong> {formatAmount(loan.loanAmount)}
        </div>

        <div>
          <strong>EMI Amount:</strong> {formatAmount(emiAmountFromSchedule)}
        </div>

        <div>
          <strong>Number of EMI:</strong> {allEmis.length}
        </div>

        <div>
          <strong>Exit Amount:</strong> {formatAmount(loan.loanPayable)}
        </div>
      </section>

      <section className="AdminLoanCardPage-table">
        <h2 className="loan-card-page-header">EMI Schedule</h2>

        <table>
          <thead>
            <tr>
              <th>EMI No</th>
              <th>Due Date</th>
              <th>Principal</th>
              <th>Interest</th>
              <th>EMI Amount</th>
              <th>Payment Date</th>
              <th>Staff Sign</th>
              <th>Customer Sign</th>
            </tr>
          </thead>

          <tbody>
            {allEmis?.map((emi, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{formatDate(emi.dueDate)}</td>
                <td>{formatAmount(emi.principalComponent)}</td>
                <td>{formatAmount(emi.interestComponent)}</td>
                <td>{formatAmount(emi.emiAmount)}</td>
                <td>
                  {emi.lastPaidDate ? formatDate(emi.lastPaidDate) : "-"}
                </td>
                <td></td>
                <td></td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      <div className="AdminLoanCardPage-btn-wrapper">
        <button
          className="AdminLoanCardPage-download-btn"
          onClick={downloadPageAsPDF}
        >
          📥 Download PDF
        </button>
      </div>
    </div>
  );
};

export default GoldLoanCard;